<template>
  <layout-panel hide-collapse
                :body-style="bodyStyle">
    <template slot="header">
      Q{{ index + 1 }} {{ types[question.type] }} 属性设置
    </template>
    <el-form :model="question"
             size="mini"
             @submit.native.prevent>
      <el-form-item v-if="displayFields.includes('titleAlias')"
                    label="标题别名">
        <el-input v-model="question.titleAlias"
                  :disabled="disabled"
                  placeholder="请输入标题别名"></el-input>
      </el-form-item>
      <el-form-item v-if="displayFields.includes('textPrefix')"
                    label="二检描述">
        <el-input v-model="question.textPrefix"
                  :disabled="disabled"
                  placeholder="多促销员二次检查描述"></el-input>
      </el-form-item>
      <el-form-item v-if="displayFields.includes('jumpTargetId')"
                    label="跳转到题">
        <el-select v-model="question.jumpTargetId"
                   placeholder="请选择"
                   :disabled="disabled"
                   clearable>
          <el-option label="结束答题"
                     value="end"></el-option>
          <template v-if="scope === 'clb'">
            <el-option label="下一个产品"
                       value="nextProduct"></el-option>
            <el-option label="下一个模板"
                       value="nextTemplate"></el-option>
          </template>
          <el-option :label="getLabel(item, key)"
                     :value="item.id"
                     v-for="(item,key) in questions"
                     v-if="isJump(key)"
                     :key="key"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="displayFields.includes('referIds')"
                    label="审核参考">
        <el-select v-model="question.referIds"
                   placeholder="请选择"
                   multiple
                   collapse-tags
                   :disabled="disabled"
                   class="step-template-question-attr-multiple-select">
          <el-option :label="getLabel(item, key)"
                     :value="item.id"
                     v-for="(item,key) in questions"
                     :key="key"
                     v-if="(key !== index)"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="displayFields.includes('evidenceType')"
                    label="证据类型">
        <el-select v-model="question.evidenceType"
                   :disabled="disabled"
                   placeholder="请选择">
          <el-option :label="item.label"
                     :value="item.value"
                     v-for="(item,key) in evidenceOptionType"
                     :key="key"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="displayFields.includes('reportedTablesAssociationStepId')"
                    label="宴桌数关联题">
        <el-select v-model="question.reportedTablesAssociationStepId"
                   placeholder="请选择"
                   collapse-tags
                   :disabled="disabled"
                   style="width: 150px;"
                   class="step-template-question-attr-multiple-select">
          <el-option :label="getLabel(item, key)"
                     :value="item.id"
                     v-for="(item,key) in questions"
                     :key="key"
                     v-if="isBefore(item, key)"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="displayFields.includes('imageRecognitionType')"
                    label="图像识别">
        <el-select v-model="question.imageRecognitionType"
                   placeholder="请选择"
                   :disabled="disabled"
                   multiple>
          <el-option :label="item.label"
                     :value="item.value"
                     v-for="(item,key) in imageRecognitionType"
                     :key="key"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="displayFields.includes('takePhotoAuxiliaryLine')"
                    label="拍照辅助线">
        <el-select v-model="question.takePhotoAuxiliaryLine"
                   placeholder="请选择"
                   :disabled="disabled"
                   style="width: 166px;">
          <el-option :label="item.label"
                     :value="item.value"
                     v-for="(item,key) in takePhotoAuxiliaryLineType"
                     :key="key"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="displayFields.includes('evidenceQuality')"
                    label="证据品质">
        <el-select v-model="question.evidenceQuality"
                   :disabled="disabled"
                   placeholder="请选择">
          <el-option :label="item.label"
                     :value="item.value"
                     v-for="(item,key) in evidenceQuality"
                     :key="key"></el-option>
        </el-select>
      </el-form-item>

      <!--   输入类型以及输入范围   -->
      <attr-input-type v-if="displayFields.includes('inputType')"
                       v-model="question"
                       :disabled="disabled"/>

      <el-form-item v-if="displayFields.includes('clarity')"
                    label="清晰度"
                    label-width="68px">
        <el-select v-model="question.clarity"
                   :disabled="disabled"
                   placeholder="请选择">
          <el-option :label="item.label"
                     :value="item.value"
                     v-for="(item,key) in clarity"
                     :key="key"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="displayFields.includes('delay')"
                    label="步骤延迟">
        <el-input-number v-model="question.delay"
                         :disabled="disabled"
                         :min="0"
                         :controls="false">
        </el-input-number>
        <span> 秒</span>
      </el-form-item>
      <el-form-item v-if="['info','text','select'].includes(question.type)"
                    label="数据标签">
        <el-input v-model="question.dataLabel"
                  placeholder="最多不超过50个字符"
                  :disabled="disabled"
                  maxlength="50"></el-input>
      </el-form-item>
      <el-form-item v-if="displayFields.includes('minDuration')"
                    label="录制时长">
        <el-input-number v-model="minDuration"
                         :disabled="disabled"
                         :min="0"
                         :controls="false">
        </el-input-number>
        <span> 分钟</span>
      </el-form-item>
      <el-form-item v-if="displayFields.includes('needEvidence')"
                    label="需要用户上传证据">
        <el-switch v-model="question.needEvidence"
                   :disabled="disabled || index === 0"></el-switch>
      </el-form-item>
      <el-form-item v-if="displayFields.includes('allowReusePhoto')"
                    label="允许复用已拍摄的照片">
        <el-switch v-model="question.allowReusePhoto"
                   :disabled="disabled"></el-switch>
      </el-form-item>
      <el-form-item v-if="displayFields.includes('localFile')"
                    label="允许上传本地文件">
        <el-switch v-model="question.localFile"
                   :disabled="disabled"></el-switch>
      </el-form-item>
      <el-form-item v-if="displayFields.includes('takePhotoScene')"
                    label="陈列分组拍摄">
        <el-select v-model="question.takePhotoScene"
                   :disabled="disabled"
                   placeholder="请选择"
                   style="width: 150px;">
          <el-option v-for="item in takePhotoScenes.options"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="displayFields.includes('allowCrossSubjectRecord')"
                    label="允许跨题录制">
        <el-switch v-model="question.allowCrossSubjectRecord"
                   :disabled="disabled"></el-switch>
      </el-form-item>
      <el-form-item label="强制观看任务指引视频">
        <el-switch v-model="question.forceGuideAudio"
                   :disabled="disabled"></el-switch>
      </el-form-item>
      <el-form-item label="强制观看任务指引音频">
        <el-switch v-model="question.forceGuideVideo"
                   :disabled="disabled"></el-switch>
      </el-form-item>
      <el-form-item v-if="displayFields.includes('intelligentCall')"
                    label="开启智能外呼">
        <el-switch v-model="question.intelligentCall"
                   :disabled="disabled"></el-switch>
      </el-form-item>
      <el-form-item label="人员检查">
        <el-switch v-model="question.ondutyCheck"
                   :disabled="disabled"></el-switch>
      </el-form-item>
      <el-form-item v-if="displayFields.includes('throughRecordKeyQuestion') && through_record" label="关键题目">
        <el-switch v-model="question.throughRecordKeyQuestion"
                   :disabled="disabled"></el-switch>
      </el-form-item>
      <el-form-item v-if="displayFields.includes('allow_screen_capture')"
                    label="允许截图和录屏">
        <el-switch v-model="question.allow_screen_capture"
                   :active-value="1"
                   :inactive-value="2"
                   :disabled="disabled"></el-switch>
      </el-form-item>
      <el-form-item v-if="displayFields.includes('allow_media_download')"
                    label="允许下载图片和视频">
        <el-switch v-model="question.allow_media_download"
                   :active-value="1"
                   :inactive-value="2"
                   :disabled="disabled"></el-switch>
      </el-form-item>
    </el-form>
  </layout-panel>
</template>

<script>
import evidenceTypes from '@views/question-editor/format/convert-fields/evidence-types'
import questionTypes from '@views/question-editor/format/convert-fields/question-types'
import * as takePhotoScenes from '@views/question-editor/format/take-photo-scenes'
import AttrInputType from '@views/step-template/components/attrs/AttrInputType'
import draggable from 'vuedraggable'
import { formRules } from '../step-template.rules.js'

export default {
  components: {
    AttrInputType,
    draggable,
  },
  inject: ['scope'],
  props: {
    value: Object,
    index: Number,
    questions: Array,
    disabled: Boolean,
    bodyStyle: [String, Array, Object],
    through_record: Boolean,
  },
  data () {
    return {
      formRules,
      takePhotoScenes
    }
  },
  computed: {
    ...Vuex.mapState('stepTemplate', {
      types: state => state.types,
      evidenceType: state => state.evidenceType,
      imageRecognitionType: state => state.imageRecognitionType,
      takePhotoAuxiliaryLineType: state => state.takePhotoAuxiliaryLineType,
      evidenceQuality: state => state.evidenceQuality,
      clarity: state => state.clarity,
    }),
    // 全程录音调整
    evidenceOptionType () {
      return this.evidenceType
    },
    question: {
      get () {
        if (this.index === 0) {
          this.value.needEvidence = false
        }
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      },
    },
    minDuration: {
      get () {
        return this.question.minDuration / 60
      },
      set (value) {
        this.question.minDuration = (value * 60).toString()
      },
    },
    displayFields () {
      let fields = _.difference(questionTypes[this.question.type], evidenceTypes.evidence)
      // 显示证据选项配置
      if (this.question.type === 'select') {
        fields.push(...evidenceTypes.selectTypes[this.question.evidenceType])
      } else if (fields.includes('needEvidence') && this.question.needEvidence) {
        fields.push(...evidenceTypes.types[this.question.evidenceType])
      }
      return fields
    },
  },
  watch: {},
  created () {},
  mounted () {},
  methods: {
    getLabel (item, index) {
      return 'Q' + (index + 1) + '-' + item.title
    },
    isJump (key) {
      return key > this.index
    },
    isBefore (question, key) {
      return key < this.index && question.type === 'text'
    },
  },
  filters: {},
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/step-template/components/StepTemplateQuestionAttr.vue